// extracted by mini-css-extract-plugin
export var cancelButton = "_pq-5";
export var content = "_pq-3";
export var createButton = "_pq-6";
export var drawerContainer = "_pq-0";
export var footer = "_pq-2";
export var header = "_pq-1";
export var orderFormColumn = "_pq-4";